import { IncidentDetailsPage } from "./incident/IncidentDetails";
import { IncidentListPage } from "./incident/IncidentListPage";
import { LogsPage } from "./LogsPage";
import { ConfigListPage } from "./config/ConfigList";
import { ConfigDetailsPage } from "./config/details/ConfigDetailsPage";
import { ConfigChangesPage } from "./config/ConfigChangesPage";
import { ConfigDetailsChangesPage } from "./config/details/ConfigDetailsChangesPage";
import { TopologyPage } from "./TopologyPage";

export {
  LogsPage,
  ConfigDetailsPage,
  ConfigListPage,
  ConfigChangesPage,
  ConfigDetailsChangesPage,
  TopologyPage,
  IncidentDetailsPage,
  IncidentListPage
};
